import { render, staticRenderFns } from "./task-center.vue?vue&type=template&id=20ddddcc&scoped=true&"
import script from "./task-center.vue?vue&type=script&lang=js&"
export * from "./task-center.vue?vue&type=script&lang=js&"
import style0 from "./task-center.less?vue&type=style&index=0&id=20ddddcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ddddcc",
  null
  
)

export default component.exports